<template lang="pug">
div
  el-card.card-container(shadow="hover")
    .searchPanel
      h3.titulo {{ 'Pesquisa simplificada' }}
      el-input.input(
        placeholder="Informe o número do processo",
        class="input-with-select",
        v-model="numProcesso",
        @keyup.native.enter="pesquisar"
      )
        el-button.color-default(
          slot="append",
          icon="el-icon-search",
          id='botao-filtro-simplificado'
          @click="pesquisar"
        )
        span Pesquisar
    .button-group
      .left-buttons
        el-button.no-padding(
          type="text"
          id='botao-limpar',
          @click="limpar"
        ) Limpar
  el-card.card-container(v-if="processo" shadow="hover")
    card-mover-processo(
      :processo="processo"
      :opcoesAcoes="true",
      :isMaranhao="this.isMaranhao()"
    )
  el-card.card-container(shadow="hover" v-if="processo")
    el-row.caixa-pesquisa(:gutter="30")
      el-col(:span="24", v-if="processo")
        app-divider(label="Mover processo")
        app-label(label="Selecione o setor que deseja mover o processo:", style="margin-top: 20px")
        el-select.select(
          placeholder="Selecione a caixa",
          class="input-with-select",
          v-model="setor",
          class="select",
          filterable
        )
          el-option(
            v-for="setor in setoresFluxo",
            :key="setor.acao",
            :label="setor.nome",
            :value="setor.acao"
          )
    el-row.caixa-pesquisa(:gutter="30", v-if="processo")
      el-col(:span="24")
        div(class="botao-processo", v-if="processo && this.isMaranhao()")
          el-button.btn(
            type="primary",
            @click="openModalNotificacao()",
          )
            span.center
              i.fa.fa-file.icon
              b &nbsp Modelo
        h4(style="margin-top: 10px; margin-bottom:30px") Justificativa:
        app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="mensagem",
            ref="editorTexto"
          )
        app-anexo(
          :id="'upload-anexo-despacho'",
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
          :tipoExibir="'ANEXO_ANALISE'"
        )
        div.botao-processo
          div
            el-button(
              type="primary"
              @click="moverProcesso"
              class="button-mover"
            )
              span.center
                b Mover &nbsp
                i.fas.fa-chevron-right

      el-col(:span="12")
       app-modal-distribuicao(
          :processo="processo",
          :mensagem="mensagemFormatada",
          :tarefa="tarefa",
          :anexos="anexos"
          @closeModal="closeModal",
          @limparDados="limpar"
          v-if="openModal"
        )
      el-col(:span='12')
        app-modal-selecionar-modelo-notificacao(
          :tiposModelo="tiposModelo",
          titulo='Modelos de Justificativa',
          :idProcesso="processo.id"
          v-if="showModalNotificacao",
          :showModal="showModalNotificacao"
          @closeModal="fecharModalNotificacao",
          @setTextoJustificativa="setTextoJustificativa"
        )
</template>
<script>
import { parseString } from 'xml2js'
import axios from '@/utils/api'
import AppLabel from '@/components/AppLabel'
import {buscarProcesso, getXmlFluxo, moverProcessoMa, buscarTarefa} from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppOpcoesHeaderAnalise from '../analise/components/modal/AppOpcoesHeaderAnalise.vue'
import CardMoverProcesso from './components/CardMoverProcessos.vue'
import AppModalDistribuicao from './components/modal/AppModalDistribuicao.vue'
import AppModalSelecionarModeloNotificacao from '../../screens/analise/components/AppModalSelecionarModeloNotificacao.vue'
import AppDivider from '../../components/AppDivider.vue'
import FileSaver from 'file-saver'
import AppAnexo from '@/components/AppAnexo'
const { fluxosAssinatura } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppLabel,
    AppEditorTexto,
    AppOpcoesHeaderAnalise,
    CardMoverProcesso,
    AppModalDistribuicao,
    AppModalSelecionarModeloNotificacao,
    AppDivider,
    AppAnexo
  },
  data () {
    return {
      numProcesso: '',
      mensagem: '',
      processo: null,
      setor: null,
      setoresFluxo: null,
      tarefa: null,
      openModal: false,
      showModalNotificacao: false,
      tiposModelo: [7],
      conversaAberta: false,
      anexos: [],
      deletaAssinatura: false
    }
  },

  mixins: [
    AppNotificacao
  ],
  computed: {
    mensagemFormatada () {
      return this.mensagem.replace(/<[\w\s="-:;]+>*|&nbsp;*|<\/\w+>/g, '').replace(/( ){2,}/g, '$1').trim()
    }
  },
  async mouted () {
    this.getConversaPerdidaPendente()
  },
  methods: {
    async pesquisar () {
      this.processo = null
      this.tarefa = null
      if (!this.numProcesso || this.numProcesso === '') this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      else {
        const response = await buscarProcesso(this.numProcesso)
        if (response != null) {
          const taskResponse = await buscarTarefa(response.id)
          this.processo = response
          if (taskResponse) {
            if (['ARQUIVAMENTO', 'ARQUIVADO', 'INDEFERIDO', 'INDEFERIMENTO'].some(term => taskResponse.nameKeyCurrentTask.includes(term))) {
              this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Processos em arquivamento não podem ser movidos.')
              this.processo = null
              return
            }
            this.tarefa = {
              name: taskResponse.nameKeyCurrentTask,
              acoes: taskResponse.nextDecisions.map(d =>
                ({nome: d.label ? d.label : d.codigo, valor: d.codigo}))}
            const { xml, fluxosProcesso } = await getXmlFluxo(response.numeroProcesso, response.tipo.codigo)
            parseString(xml, (_, results) => {
              const { encontrados } = this.dividirArrayAteUltimoMatch(fluxosProcesso)
              // Processa setores com filtrarSetoresFluxo
              let setoresFiltrados = this.filtrarSetoresFluxo(results.definitions.process[0].callActivity, encontrados)

              // Remove duplicados do array setoresFiltrados
              setoresFiltrados = setoresFiltrados.filter((item, index, self) =>
                index === self.findIndex(t => t.acao === item.acao)
              )

              this.setoresFluxo = setoresFiltrados
            })
            this.getConversaPerdidaPendente()
          }
        } else {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            'Não foi encontrado processo com número informado.')
        }
      }
    },
    dividirArrayAteUltimoMatch (fluxosProcesso) {
      // Obtém o valor do último elemento do array
      const valorProcurado = fluxosProcesso[fluxosProcesso.length - 1].idFluxo

      // Percorre o array do início até encontrar o valor
      let indexEncontrado = -1
      for (let i = 0; i < fluxosProcesso.length; i++) {
        if (fluxosProcesso[i].idFluxo === valorProcurado) {
          indexEncontrado = i
          break
        }
      }

      // Se encontrou o valor, divide o array
      if (indexEncontrado !== -1) {
        const arrayDividido = fluxosProcesso.slice(0, indexEncontrado + 1)
        const restantes = fluxosProcesso.slice(indexEncontrado + 1)

        return {
          encontrados: arrayDividido,
          restantes: restantes
        }
      }

      // Caso não encontre, retorna o array completo
      return { encontrados: fluxosProcesso, restantes: [] }
    },
    filtrarSetoresFluxo (callActivities, fluxosProcesso) {
      const status = ['INICIAR', 'ARQUIVAMENTO', 'FINALIZADO', 'ARQUIVADO', 'ARQUIVADOS', 'FINALIZADOS', 'INDEFERIDO']
      // Filtra `callActivities` mantendo apenas aqueles que não estão nos status de exclusão e que existem em `fluxosProcesso`
      const setoresFiltrados = callActivities
        .filter(o => {
          const nome = o['$'].name
          const acao = o['$'].id
          return (
            !status.some(status => nome.toUpperCase().includes(status)) &&
            acao &&
            !status.some(status => acao.toUpperCase().includes(status)) &&
            fluxosProcesso.some(ff => ff.idFluxo === acao)
          )
        })

      // Ordena `setoresFiltrados` de acordo com a ordem de `fluxosProcesso`
      const setoresOrdenados = fluxosProcesso
        .map(ff => {
          const setor = setoresFiltrados.find(f => f['$'].id === ff.idFluxo)

          // Verifica se o setor existe e altera o nome caso seja o ID desejado
          if (setor) {
            if (setor['$'].id === 'SUB_FLUXO_DATGL') {
              setor['$'].name = 'DATGL análise da malha'
            }
          }

          return setor
        })
        .filter(f => f && f['$'].id !== 'SUB_FLUXO_COMISSAO_ILHA_REURB_INDIVIDUAL')
      // Mapeia para o formato desejado
      return setoresOrdenados.map(o => ({
        nome: o['$'].name,
        acao: o['$'].id
      }))
    },
    onTextChange (text) {
      this.mensagem = text
    },
    setTextoJustificativa (mensagem) {
      this.$refs.editorTexto.text = mensagem
      this.$refs.editorTexto.emitTextChange()
    },
    async moverProcesso () {
      const mensagem = this.mensagem.replace(/<[\w\s="-:;]+>*|&nbsp;*|<\/\w+>/g, '').replace(/( ){2,}/g, '$1').trim()
      if (mensagem.length > 10 && ((this.processo.status === 'AGUARDANDO_ANALISE_DISTRIBUICAO') || (this.processo.status === 'AGUARDANDO_DISTRIBUICAO'))) {
        this.openModal = true
        return
      }
      if (!this.setor && (this.processo.status !== 'AGUARDANDO_ANALISE_DISTRIBUICAO' && this.processo.status !== 'AGUARDANDO_DISTRIBUICAO')) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Selecione a caixa')
      else if (this.conversaAberta === true || this.processo.retificacao === true) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Processo com pendência')
      else if (mensagem.length < 10) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'O campo "Motivo da mudança" deve estar preenchido com no minímo 10 caracteres')
      else {
        const contemfluxoAssinatura = this.setoresFluxo.some(setor => fluxosAssinatura.includes(setor.acao))

        const indexAlvo = this.setoresFluxo.findIndex(obj => obj.acao === this.setor)
        const arrayAlvo = this.setoresFluxo.slice(0, indexAlvo + 1)
        this.deletaAssinatura = !arrayAlvo.some(setor => fluxosAssinatura.includes(setor.acao)) && contemfluxoAssinatura
        const response = await moverProcessoMa(this.processo.id, this.setor, this.mensagem, this.deletaAssinatura, this.anexos)
        if (!response) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Erro ao mover processo, verifique sua conexão')
        else {
          this.processo = await buscarProcesso(this.numProcesso)
          this.setor = null
          if (this.processo.status.includes('DISTRIBUICAO')) {
            await this.atualizaTarefa()
            this.openModal = true
            return
          }
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo movido')
          this.limpar()
        }
      }
    },
    async atualizaTarefa () {
      const taskResponse = await buscarTarefa(this.processo.id)
      if (!taskResponse) {
        return
      }
      this.tarefa = {
        name: taskResponse.nameKeyCurrentTask,
        acoes: taskResponse.nextDecisions.map(d => ({
          nome: d.label || d.codigo,
          valor: d.codigo
        }))
      }
    },
    async limpar () {
      this.processo = null
      this.setor = null
      this.setoresFluxo = null
      this.numProcesso = ''
      this.mensagem = ''
      this.openModal = false
      this.anexos = []
    },
    closeModal () {
      this.openModal = false
    },
    openModalNotificacao () {
      this.showModalNotificacao = true
    },

    fecharModalNotificacao () {
      this.showModalNotificacao = false
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    async getConversaPerdidaPendente () {
      axios({
        method: 'GET',
        url: `conversa/processo/${this.processo.id}/solicitacao/aberta`
      })
        .then((existe) => {
          this.conversaAberta = existe
        })
    },
    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },
    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.id === documento.id)
        )
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.key === documento.key)
        )
        this.anexos.splice(index, 1)
      }
    },
    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }
  }
}
</script>
<style lang="scss" scoped>
    $font-size-small: 12px;

    .color-default {
      color: white;
      font-size: 16px;
    }
    .botao-limpar {
      color: #009d64 !important;
      font-size: 16px;
      border: none;
      background-color: none;
    }
    .caixa-pesquisa {
      margin-bottom: 10px;
    }
    .pesquisa {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .span-titulo {
      margin-top: 0;
      margin-bottom: 3px;
      font-size: 32px;
      margin-left: 20px;
    }
    .box-processo {
      min-width: 700px;
      padding-left: 3px;
      padding-right: 3px;
    }
    .select {
      margin-right: 20px;
      margin-top: none;
      margin-bottom: 5px;
    }
    .span-style {
      font-weight: normal;
    }
    .center {
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
    }
    .box-titulo {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .col-principal {
      width: 100%;
      min-width: 685px;
    }
    .botao-processo {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .right {
      align-items: right;
    }
    .button-mover {
      margin-top: 15px;
    }
    .card-container {
      margin: 20px;
      border-radius: 10px;
    }
    .searchPanel {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    .button-group {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 15px;
    }

    .no-padding {
      padding: 0;
    }

    .panel {
      .margin-top {
        margin-top: 10px;
      }

      .titulo {
        font-size: 14px;
      }
    }

    .btn {
      padding: 8px;
    }
  }
  .color-default {
    color: #009d64 !important;
    font-size: 16px;
  }
  .card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/MoverProcessos.vue